export enum Endpoints {
    LOGIN = 'seguridad/acceder',
    GET_PROFILE = 'usuario/perfil',
    LOGOUT = 'seguridad/cerrar-acceso',
    SEND_LINK = 'seguridad/solicitar-cambio',
    CHANGE_PASSWORD = 'seguridad/cambiar-contrasenia',
    GET_COUNTRIES = 'usuario/pais',
    GET_RANGES = 'usuario/rango',
    GET_DOCUMENTS = 'usuario/tipo-documento',
    SAVE_USER = 'usuario/registro',
    GET_USERS = 'usuario/asesores',
    SAVE_COURSE = 'entrenamiento/registrar-curso',
    GET_COURSES = 'entrenamiento/listar',
    SAVE_MODULE = 'entrenamiento/registrar-modulo',
    DELETE_MODULE = 'entrenamiento/eliminar-modulo',
    DELETE_COURSE = 'entrenamiento/eliminar-curso',
    SAVE_SESSION = 'entrenamiento/registrar-sesion',
    GET_QUESTIONS = 'entrenamiento/listar-examen',
    SAVE_HEAD_QUESTION = 'entrenamiento/registrar-examen',
    DELETE_EXAMN = 'entrenamiento/eliminar-examen',
    SAVE_QUESTION_EXAM = 'entrenamiento/registrar-pregunta',
    DELETE_QUESTION_EXAMEN = 'entrenamiento/eliminar-pregunta',
    GET_PRODUCTS = 'producto/listar',
    SAVE_PRODUCT = 'producto/registrar',
    DELETE_PRODUCT = 'producto/eliminar',
    DELETE_QUESTION_PRODUCT = 'producto/eliminar-pregunta',
    SAVE_QUESTION_PRODUCT = 'producto/registrar-pregunta',
    ACTIVE_COURSE = 'entrenamiento/activar',
    ACTIVE_PRODUCT = 'producto/activar',
    GET_CLIENTS = 'cliente/listar',
    GET_SALARIES = 'cliente/ingreso-anual',
    GET_HERITAGES = 'cliente/patrimonio',
    GET_INCOMES = 'cliente/tipo-ingreso',
    SAVE_CLIENT = 'cliente/registrar',
    GET_STATES_CLIENT = 'cliente/listar-estado',
    CHANGE_STATE_CLIENT = 'cliente/cambiar-estado',
    SAVE_COMMENT = 'cliente/comentario',
    REGISTER_START_COURSE = 'entrenamiento/iniciado',
    REGISTER_EXAMN_COURSE = 'entrenamiento/examen',
    REGISTER_EXAMN_PRODUCT = 'cliente/registrar-producto',
    SAVE_PRODUCTS_INTERESTED = 'cliente/producto-interes',
    SAVE_FOLDER = 'directorio/registrar',
    DELETE_FOLDER = 'directorio/eliminar',
    GET_FOLDERS = 'directorio/listar',
    SAVE_FILE_FOLDER = 'directorio/contenido',
    ADD_POINTS_AGENT = 'usuario/asesor-puntos',
    GET_DASHBOARD_USER = 'usuario/dashboard-asesor',
    GET_DASHBOARD_GENERAL = 'usuario/dashboard-general',
    GET_DASHBOARD_GRAPHIC = 'usuario/dashboard-grafico',
    DELETE_FILE = 'directorio/eliminar-contenido',
    SAVE_TABLET = 'pastillas/registrar',
    DELETE_TABLET = 'pastillas/eliminar',
    GET_TABLETS = 'pastillas/listar',
    SAVE_FILE_TABLET = 'pastillas/contenido',
    DELETE_FILE_TABLET = 'pastillas/eliminar-contenido',
    GET_MENU = 'seguridad/menu',
    GET_PLANS = 'plan/listar',
    UPDATE_PLAN = 'seguridad/cambiar-plan',
    GET_BILLING_HISTORY = 'seguridad/historial-pagos',
    BEGIN_ONBOARDING = 'seguridad/onboarding',
    CREATE_PORTAL_SESSION = 'seguridad/portal-pagos',
    DELETE_USER = 'usuario/eliminar',
    DELETE_CLIENT = 'cliente/eliminar'
}